export enum TRACKING_EVENT_ACTION_SUBJECT_IDS {
    userSegRedesignScreen = "userSegRedesignScreen",
    teamFocusCard = "teamFocusCard",
    teamFocusNext = "teamFocusNextButton",
    teamFocusGetStarted = "teamFocusGetStartedButton",
    teamFocusTeamTypeButton = "teamFocusTeamTypeButton",
    templateChoiceCard = "templateChoiceCard",
    templateChoiceStartNow = "templateChoiceStartNow",
    templateChoiceBack = "templateChoiceBackButton",
    templateChoiceNext = "templateChoicieNextButton",
    templateChoiceTeamTypeSelect = "templateChoiceTeamTypeSelect",
    projectNamingBack = "projectNamingBackButton",
    projectNamingStartNow = "projectNamingStartNow",
    workflowStyleBackClicked = "workflow-style-back-button-clicked",
    workflowStyleGetStartedClicked = "workflow-style-get-started-button-clicked"
}

export const ATLAS_TICKET = "ATLAS-58859";

export enum USER_SEARCH_PARAMS {
    teamType = "team_type",
    templateChoice = "templateChoice"
}
